import type { Csv, CsvPatch, GetCsvsRequest } from '@/apis/generated/dialbunny';
import { CsvFromJSON } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type CsvStore = StoreEntity<Csv, 'id', GetCsvsRequest, File, CsvPatch>;

export const useCsvStore = apiStoreFactory<
  CsvStore['entity'],
  CsvStore['id'],
  CsvStore['filter'],
  CsvStore['createInput'],
  CsvStore['updateInput']
>(
  STORE.CSV,
  { entityIdKey: 'id' },
  {
    create: async (file: File, { dialbunnyApi }) => {
      return await dialbunnyApi.uploadCsv({
        file,
      });
    },
    readAll: async (filter, { dialbunnyApi }, signal) => {
      return await dialbunnyApi.getCsvsRaw(filter, { signal });
    },
    read: async (csvId: string, { dialbunnyApi }) => {
      return await dialbunnyApi.getCsv({ csvId });
    },
    discard: async (csvId: string, { dialbunnyApi }) => {
      await dialbunnyApi.deleteCsv({ csvId });
    },
    update: async (csvId: string, csvPatch: CsvPatch, { dialbunnyApi }) => {
      return dialbunnyApi.updateCsv({ csvId, csvPatch });
    },
    bulkRead: async (csvIds: string[], { dialbunnyApi }) => {
      const csvs = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Csv',
        ids: csvIds.join(','),
      });

      return csvs.map(CsvFromJSON);
    },
  },
);
